const ACCESS_TOKEN_KEY = 'ufoAccessToken';

export const tokenController = () => sessionStorage.getItem(ACCESS_TOKEN_KEY);

export const setAccessToken = (token: string | null) => {
    if (token) sessionStorage.setItem(ACCESS_TOKEN_KEY, token);
    else sessionStorage.removeItem(ACCESS_TOKEN_KEY);
};

export const clearLegacyTokens = () => {
    localStorage.removeItem('fakeToken');
    localStorage.removeItem('invoiceToken');
    localStorage.removeItem('deliveryNoticeToken');
};
